import React,{ Component } from 'react'
import { NavLink } from 'react-router-dom'
import { connect } from 'react-redux'
import { guardaCustom }  from '../actions'
import { refStorageTemp } from "../config/firebase";
import html2canvas from 'html2canvas'

class CustomPreview extends Component{

  constructor(props) {
    super(props);
    this.state = {
      resultado:"",
      fondocolor:"#ffffff",
      printArea:{
        width_cont: 1024,
        heigth_cont: 152,
        image:"imgs/TyvekNaranjaFluo.png",
        width: '412px',
        height: '56px', 
        marginLeft:'133px',
        marginTop:'48px',
        color_fx:1, //1 MULTIPLY 2 SIN EFECTO
        color_tipo:"FC" //FC FULLCOLOR MC MONOCOLOR MN MONOCROMATICO NEGRO
      },
      objeto:{
        tipo:1,
        back:"",
        fuente:"",
        contenido:"",
        color:"",
        tamano:14,
        x:0,
        y:0,
        w:150,
        h:50
      },
      objetos:[
      ]
    }
    this.capturaCustom = this.capturaCustom.bind(this)
  }
     
  componentDidMount() {
    //console.log("ACA")
    //console.log(this.props.producto);
    var printArea = {
      width_cont: this.props.producto.custom_data.width_cont,
      heigth_cont: this.props.producto.custom_data.heigth_cont,
      width: this.props.producto.custom_data.width,
      height: this.props.producto.custom_data.height,
      marginLeft: this.props.producto.custom_data.marginLeft,
      marginTop: this.props.producto.custom_data.marginTop,
      color_fx: this.props.producto.custom_data.color_fx,
      color_tipo: this.props.producto.custom_data.color_tipo
    }
    //console.log(printArea);
    this.setState({
      printArea:printArea
    })
  }

  componentDidUpdate(prevProps, prevState){
    //console.log(this.state.printArea)
    var printArea = {
      width_cont: this.props.producto.custom_data.width_cont,
      heigth_cont: this.props.producto.custom_data.heigth_cont,
      width: this.props.producto.custom_data.width,
      height: this.props.producto.custom_data.height,
      marginLeft: this.props.producto.custom_data.marginLeft,
      marginTop: this.props.producto.custom_data.marginTop,
      color_fx: this.props.producto.custom_data.color_fx,
      color_tipo: this.props.producto.custom_data.color_tipo
    }
    if (this.state.printArea.width_cont !== printArea.width_cont || this.state.printArea.heigth_cont !== printArea.heigth_cont) {
     // console.log(printArea);
      this.setState({ printArea: printArea });
    }
  }

    async capturaCustom(){

    const canvas = await  html2canvas(document.querySelector("#canva_" + this.props.producto.id), {
      //allowTaint: true,
      useCORS: true,
      //taintTest: false,
      scale:5,
      //logging:true
    });
      let imgData = canvas.toDataURL('image/png');
      this.setState({
        resultado: imgData
      })

  }

  render() {
    var class_fx=""
    var archivos=[]
    var conta=1
    if(this.state.color_fx === 1){
      class_fx="backCustomApp"
    }

    const  objetosTxt = this.props.producto.custom_objs.map((objeto,i)=>{
      var tamano=parseInt(objeto.tamano) 
        if(objeto.tipo==1){
          return (
            <div key={i} style={{ position: 'absolute', top: objeto.y + "px", left: objeto.x + "px",margin: 0, height: objeto.h,width:objeto.w}}  className="imgCustomApp">
              <h2 className="sinBlend" style={{fontSize:parseInt(objeto.tamano),color:objeto.color,fontFamily:objeto.fuente,overflow:'hidden'}}  dangerouslySetInnerHTML={{__html:objeto.contenido.replace(/\r?\n/g, '<br />')}}></h2> 
            </div>
          )
        }
    })

    const objetosImgs = this.props.producto.custom_objs.map((objeto, i) => {
      var tamano = parseInt(objeto.tamano)
      if (objeto.tipo == 2) {
        archivos.push(<li key={i+555}><a href={objeto.fuente} target="_blank" >{"IMAGEN "+conta}</a></li>);
        conta++
        return (
          <div key={i} style={{ position: 'absolute', top: objeto.y, left: objeto.x, margin: 0, height: objeto.h, width: objeto.w }} className="imgCustomApp">
            <img src={objeto.fuente} style={{ width: '100%', height: "100%" }} />
          </div>
        )
      }
    })

    return <section className="container-fluid mb-5 sombraHead mt-3 clearfix">
        <section style={{ backgroundImage: 'url("https://firebasestorage.googleapis.com/v0/b/veltonaccesos-113f7.appspot.com/o/custom%2F' + this.props.producto.id + '.png?alt=media")', width: this.state.printArea.width_cont, height: this.state.printArea.heigth_cont, marginTop: 60, marginBottom: 30, paddingTop: this.state.printArea.marginTop }} className={class_fx}>
          <section id={"canva_" + this.props.producto.id} style={{ width: this.state.printArea.width, height: this.state.printArea.height, marginLeft: this.state.printArea.marginLeft, border: 0, position: "relative" }} className={class_fx + " printArea"}>
            {objetosImgs}
            {objetosTxt}
          </section>
        </section>
        <button onClick={this.capturaCustom}>GENERAR IMAGEN</button>
        <section>
          <img src={this.state.resultado} />
        </section>
        {archivos.length>0 &&
        <ul>
        {archivos}
        </ul>
        }
      </section>;
      
  }
}
/*
const mapStateToProps = (state, ownProps) => {
    return {
      carro: state.productos.carro,
      usuario: state.usuario
    }
}

const mapDispatchToProps = dispatch => {
  return {
    guardaCustom:(id_prod, customObjs) => {
      dispatch(guardaCustom(id_prod, customObjs))
    }
  }
}
*/
export default CustomPreview




// WEBPACK FOOTER //
// ./src/containers/custom_preview.js